import { Injectable } from '@angular/core';

import {
	CreateNodeCategoryRequest,
	UpdateNodeCategoryRequest,
} from '@reach/interfaces/node-categories/node-categories.requests';
import {
	CreateNodeCategoryResponse,
	GetNodeCategoriesResponse,
	GetNodeCategoryResponse,
	UpdateNodeCategoryResponse,
} from '@reach/interfaces/node-categories/node-categories.responses';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class NodeCategoriesApiService extends BaseApiService {
	protected commonPath = ['node-categories'];

	public async getCategories(): Promise<GetNodeCategoriesResponse> {
		return await this.http.get<GetNodeCategoriesResponse>(this.url());
	}

	public async createCategory(
		body: CreateNodeCategoryRequest
	): Promise<CreateNodeCategoryResponse> {
		return await this.http.post<CreateNodeCategoryResponse>(this.url(), body);
	}

	public async getCategory(id: string): Promise<GetNodeCategoryResponse> {
		return await this.http.get<GetNodeCategoryResponse>(this.url(id));
	}

	public async updateCategory(
		id: string,
		body: UpdateNodeCategoryRequest
	): Promise<UpdateNodeCategoryResponse> {
		return await this.http.patch<UpdateNodeCategoryResponse>(this.url(id), body);
	}

	public async deleteCategory(id: string): Promise<void> {
		return await this.http.delete(this.url(id));
	}
}
